import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Collapse, Typography, CardContent } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';

import { ExpandMore } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-expand-button';

export function CollapsibleSection({
  title,
  expanded,
  setExpanded,
  children,
}: {
  title: string;
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
  children: React.ReactNode;
}) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        <ExpandMore
          expanded={expanded.toString()}
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-label={`${title} show ${expanded ? 'less' : 'more'}`}
        >
          <ExpandMoreIcon />
        </ExpandMore>
        <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
      </div>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent
          sx={{
            paddingLeft: '38px', // Adjust the padding as needed based on the width of the ExpandMore button
          }}
        >
          {children}
        </CardContent>
      </Collapse>
    </div>
  );
}
